import { contactCard } from './contactCard';

export const otherContactCard = contactCard(
  'additionalContacts.other',
  'other',
);
